@if (cloneInspectionPage) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <div mat-card-avatar>
        <mat-icon>content_copy</mat-icon>
      </div>
      <mat-card-title>Clone Inspection: {{ inspectionName }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <table width="100%">
        <tr>
          <p>
            Select the number of times you want this inspection to be cloned.<br />The
            new inspections will be named after the original one including a
            suffix if no new name is added below.
          </p>
        </tr>
        <tr>
          <mat-form-field appearance="outline">
            <mat-label>Times</mat-label>
            <mat-select
              [(value)]="defaultQuantity"
              (selectionChange)="changeQuantity($event.value)"
              >
              @for (quantity of numberQuantities; track quantity) {
                <mat-option
                  [value]="quantity"
                  >
                  {{ quantity }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </tr>
        <tr>
          <mat-form-field appearance="outline">
            <mat-label>New inspection name</mat-label>
            <input
              id="newInspectionName-input"
              [ngModel]="newInspectionName"
              (ngModelChange)="onChange($event)"
              matInput
              type="text"
              maxLength="50"
              name="newInspectionName"
              required
              />
            </mat-form-field>
          </tr>
          <tr>
            <mat-checkbox
              class="check-box"
              [disabled]="isNewInspectionState"
              (change)="checkCopyDates($event.checked)"
              >Clone inspection dates</mat-checkbox
              >
            </tr>
            <tr>
              <mat-checkbox
                class="check-box"
                (change)="checkCopyForms($event.checked)"
                >Clone all details inserted on the forms</mat-checkbox
                >
              </tr>
              <tr>
                <mat-checkbox
                  class="check-box"
                  (change)="checkCopyInspectors($event.checked)"
                  >Nominate the same inspectors
                </mat-checkbox>
              </tr>
            </table>
          </mat-card-content>
          <mat-card-actions align="end">
            <button id="cancel-clone-inspection" (click)="cancel()" mat-button>
              CANCEL
            </button>
            @if (copyDates) {
              <button
                id="clone-inspection"
                (click)="clone()"
                mat-button
                color="primary"
                >
                CLONE
              </button>
            }
            @if (!copyDates) {
              <button
                id="clone-inspection"
                (click)="next()"
                mat-button
                color="primary"
                >
                NEXT
              </button>
            }
          </mat-card-actions>
        </mat-card>
      }

      <mat-card
        [ngClass]="{ 'not-visible': cloneInspectionPage }"
        appearance="outlined"
        >
        <mat-card-header>
          <div mat-card-avatar>
            <mat-icon>date_range</mat-icon>
          </div>
          <mat-card-title>Inspection Dates</mat-card-title>
          <mat-card-subtitle
            >Select the dates for the new inspections.</mat-card-subtitle
            >
          </mat-card-header>
          <mat-card-content>
            <cotecna-nf-form
              #naturalForm
              [config]="formConfig"
              [sections]="sections"
              [controls]="controls"
              >
            </cotecna-nf-form>
          </mat-card-content>
          <mat-card-actions align="end">
            <button id="cancel-clone-inspection" (click)="back()" mat-button>
              BACK
            </button>
            <button
              id="clone-inspection"
              [disabled]="cloneButtonDisabled"
              (click)="clone()"
              mat-button
              color="primary"
              >
              CLONE
            </button>
          </mat-card-actions>
        </mat-card>
